import { NftCardWrapper } from "../components/Products/NftCard/NftCard.styled";

const addEmptyBlocks = (i) => {
  let width = window.innerWidth;
  let count;
  if (width > 1899) {
    if (i < 5) {
      if (i === 4) {
        count = 1;
      }
      if (i === 3) {
        count = 2;
      }
      if (i === 2) {
        count = 3;
      }
      if (i === 1) {
        count = 4;
      }
      if (i === 0) {
        count = 0;
      }
    } else {
      count = 5 - (i % 5);
    }
  } else if ((width < 1899) & (width > 1299)) {
    if (i < 4) {
      if (i === 3) {
        count = 1;
      }
      if (i === 2) {
        count = 2;
      }
      if (i === 1) {
        count = 1;
      }
      if (i === 0 || i === 4) {
        count = 0;
      }
    } else {
      count = 4 - (i % 4);
    }
  } else if ((width < 1299) & (width > 991)) {
    if (i < 3) {
      if (i === 2) {
        count = 1;
      }
      if (i === 1) {
        count = 2;
      }
      if (i === 0 || i === 3) {
        count = 0;
      }
    } else {
      count = 3 - (i % 3);
    }
  } else if ((width < 991) & (width > 678)) {
    if (i < 2) {
      if (i === 1) {
        count = 1;
      }
      if (i === 0 || i === 2) {
        count = 0;
      }
    } else {
      count = 2 - (i % 2);
    }
  } else {
    count = 0;
  }
  let blocks = [];
  for (let step = 0; step < count; step++) {
    blocks.push(<div style={{ opacity: 0, height: 0, width: "299px", margin: "20px auto" }} />);
  }
  return blocks;
};

export const addEmptyBlocksCreators = (i) => {
  let width = window.innerWidth;
  let count;
  if (width > 1899) {
    if (i < 5) {
      if (i === 4) {
        count = 1;
      }
      if (i === 3) {
        count = 2;
      }
      if (i === 2) {
        count = 3;
      }
      if (i === 1) {
        count = 4;
      }
      if (i === 0) {
        count = 0;
      }
    } else {
      count = 5 - (i % 5);
    }
  } else {
    count = 0;
  }
  let blocks = [];
  for (let step = 0; step < count; step++) {
    blocks.push(<div style={{ opacity: 0, height: 0, width: "299px", margin: "20px auto" }} />);
  }
  return blocks;
};

export const addEmptyBlocksProfile = (i) => {
  let width = window.innerWidth;
  let count;
  if (width > 1299) {
    if (i < 3) {
      if (i === 2) {
        count = 1;
      }
      if (i === 1) {
        count = 2;
      }
      if (i === 0 || i === 3) {
        count = 0;
      }
    } else {
      count = 3 - (i % 3);
    }
  } else if ((width < 1299) & (width > 650)) {
    if (i < 2) {
      if (i === 1) {
        count = 1;
      }
      if (i === 0 || i === 2) {
        count = 0;
      }
    } else {
      count = 2 - (i % 2);
    }
  } else {
    count = 0;
  }
  let blocks = [];
  for (let step = 0; step < count; step++) {
    blocks.push(<div style={{ opacity: 0, height: 0, width: "299px", margin: "20px auto" }} />);
  }
  return blocks;
};

export default addEmptyBlocks;
